export default "__VITE_ASSET__2352a625__"